// import React from 'react'
// import { Navigate, Outlet } from 'react-router-dom'

// const PublicRoutes = () => {

//     const isAuthenticated = localStorage.getItem('token') ? true : false;

//     return !isAuthenticated ? <Outlet /> : <Navigate to='/home' />
// }

// export default PublicRoutes


import React from 'react';
import { ROLE_TYPE } from "../utils/helper";
import { Navigate, Outlet } from 'react-router-dom';
import { setSessionFilter } from '../utils/sessionStorage';

const getRoleBasedPath = () => {
    const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
    const hasDistrictInfo = JSON.parse(localStorage.getItem('district_info') || 'false');
    let roleType = ROLE_TYPE.FIELD_COORDINATOR;
    let targetPath = "/home";
    
    switch (userData?.role) {
        case 'State Coordinator':
            roleType = ROLE_TYPE.STATE_COORDINATOR;
            targetPath = "/dashboard-overview";
            break;
        case 'Assistant State Coordinator':
            roleType = ROLE_TYPE.ASSISTANT_STATE_COORDINATOR;
            targetPath = "/dashboard-overview";
            break;
        case 'Zonal Manager':
            roleType = ROLE_TYPE.ZONAL_MANAGER;
            targetPath = "/dashboard-overview";
            break;
        case 'Supervisor':
            roleType = ROLE_TYPE.SUPER_VISOR;
            targetPath = "/dashboard-overview";
            break;
        case 'admin':
            targetPath = "/admin-home";
            break;
        case 'Field Coordinator':
        default:
            targetPath = hasDistrictInfo ? "/FieldDashboard" : "/home";
            break;
    }
    
    // Save role type to session storage if not admin
    if (userData?.role !== 'admin') {
        setSessionFilter('dashboardFilter', { role_type: roleType });
    }
    
    return targetPath;
};

const PublicRoutes = () => {
    const isAuthenticated = !!localStorage.getItem('token');

    return !isAuthenticated ? <Outlet /> : <Navigate to={getRoleBasedPath()} />;
};

export default PublicRoutes;
